import { db } from './firebase';
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
} from 'firebase/firestore';

const COLLECTION = 'invites';

export const getPendingInvitesByOrg = async (organizationId) => {
  const q = query(
    collection(db, COLLECTION),
    where('organizationId', '==', organizationId),
    where('status', '==', 'pending')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const revokeInvite = async (inviteId) => {
  await deleteDoc(doc(db, COLLECTION, inviteId));
};

/**
 * Platform-admin only: all pending email invites across every organization.
 */
export const getAllPendingInvites = async () => {
  const q = query(collection(db, COLLECTION), where('status', '==', 'pending'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};
